import { Link } from "react-router-dom";
import icon1 from "../../../assets/images/all-img/icon1.png";
import icon2 from "../../../assets/images/all-img/icon2.png";
import icon3 from "../../../assets/images/all-img/icon3.png";
import icon4 from "../../../assets/images/all-img/icon4.png";
import arrowBlackRight from "../../../assets/images/svg/arrow-black-right.svg";

export default function FeatureSectionTwo() {
	return (
		<div className="section bg-warning-400 fugu-section-padding3">
			<div className="container">
				<div className="fugu-section-title title-large">
					<h2>Combines the best features of crypto</h2>
				</div>
				<div className="row">
					<div className="col-lg-6">
						<div className="fugu-iconbox-wrap wow fadeInUpX" data-wow-delay="0s">
							<div className="fugu-iconbox-icon">
								<img src={icon1} alt="" />
							</div>
							<div className="fugu-iconbox-data">
								<h4>Industry-leading security</h4>
								<p>
									Security tokens are digital that represent & transferred ownership rights to a
									blockchain token.
								</p>
								<Link to={"/"}  className="fugu-icon-btn" >
										Discover More <img src={arrowBlackRight} alt="" />
								</Link>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="fugu-iconbox-wrap wow fadeInUpX" data-wow-delay=".20s">
							<div className="fugu-iconbox-icon">
								<img src={icon2} alt="" />
							</div>
							<div className="fugu-iconbox-data">
								<h4>Ownership over your coins</h4>
								<p>
									The most reliable way to prove ownership of crypto currencies is to sign a specified
									message with a key.
								</p>
								<Link to={"/"} className="fugu-icon-btn" >
										Discover More <img src={arrowBlackRight} alt="" />
								
								</Link>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="fugu-iconbox-wrap wow fadeInUpX" data-wow-delay=".30s">
							<div className="fugu-iconbox-icon">
								<img src={icon3} alt="" />
							</div>
							<div className="fugu-iconbox-data">
								<h4>Cold storage for most users</h4>
								<p>
									A cold wallet, otherwise known as a hardware wallet cold storage, is a physical
									device that keeps offline.
								</p>
								<Link to={"/"}  className="fugu-icon-btn" >
										Discover More <img src={arrowBlackRight} alt="" />
								
								</Link>
							</div>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="fugu-iconbox-wrap wow fadeInUpX" data-wow-delay=".40s">
							<div className="fugu-iconbox-icon">
								<img src={icon4} alt="" />
							</div>
							<div className="fugu-iconbox-data">
								<h4>Crime insurance against theft</h4>
								<p>
									Crime insurance protects a company from loss of money, securities, inventory from
									fraud events.
								</p>
								<Link to={"/"}  className="fugu-icon-btn" >
										Discover More <img src={arrowBlackRight} alt="" />
								
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
